import { ETTypeInfos } from "@cervval.js/common-dto/src/dtoModel.service";
import { keys, typeInfos } from "@cervval.js/ts-reflect";
import { BookingCalendar, BookingException, BookingSession, BookingSharing, BookingUserSession, BookingUserSpecialty, BookingWeek } from "@ehealth_tools/common-booking/src/data/booking.dto";
import { AppTableName } from "../global/global.model";
import { PaymentElementTypes } from "../payments/payment.model";
import { UsersElementTypes } from "../users/user.model";


export type BookingElementTypes = {
    "booking_calendars": BookingCalendar<AppTableName, "booking_calendars">,
    "booking_exceptions": BookingException<AppTableName, "booking_exceptions">,
    "booking_sessions": BookingSession<AppTableName, "booking_sessions">,
    "booking_weeks": BookingWeek<AppTableName, "booking_weeks">,
    "users_specialties": BookingUserSpecialty<AppTableName, "users_specialties">,
    "booking_user_sessions": BookingUserSession<AppTableName, "booking_user_sessions">,
    "booking_sharings": BookingSharing<AppTableName, "booking_sharings">
}


export type BookingElementTypeName = keyof BookingElementTypes;
export const BookingElementTypeNames: BookingElementTypeName[] = keys<BookingElementTypes>();

export const bookingTypeInfos: ETTypeInfos<BookingElementTypes, BookingElementTypes & UsersElementTypes & PaymentElementTypes> = {
    "booking_weeks": {
        keys: keys<BookingWeek>(),
        typeInfos: typeInfos<BookingWeek>()
    },
    "users_specialties": {
        keys: keys<BookingUserSpecialty>(),
        typeInfos: typeInfos<BookingUserSpecialty>()
    },
    "booking_calendars": {
        keys: keys<BookingCalendar>(),
        typeInfos: typeInfos<BookingCalendar>(),
        foreignKeys: {
            defaultWeekId: "booking_weeks"
        }
    },
    "booking_exceptions": {
        keys: keys<BookingException>(),
        typeInfos: typeInfos<BookingException>(),
        foreignKeys: {
            calendarId: "booking_calendars",
            weekId: "booking_weeks"
        }
    },
    "booking_sessions": {
        keys: keys<BookingSession>(),
        typeInfos: typeInfos<BookingSession>(),
        foreignKeys: {
            productId: "products",
            professionalId: "user_profiles"

        }
    },
    "booking_sharings": {
        keys: keys<BookingSharing>(),
        typeInfos: typeInfos<BookingSharing>(),
        foreignKeys: {
            fromId: "user_profiles",
            toId: "user_profiles"

        }
    },
    "booking_user_sessions": {
        keys: keys<BookingUserSession>(),
        typeInfos: typeInfos<BookingUserSession>(),
        foreignKeys: {
            customerId: "user_profiles",
            sessionId: "booking_sessions"

        }
    }
};